import * as React from 'react';
import '@fortawesome/fontawesome-free-webfonts';
import '@fortawesome/fontawesome-free-webfonts/css/fa-solid.css';
import '@fortawesome/fontawesome-free-webfonts/css/fa-brands.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import {applyMiddleware, combineReducers, compose, createStore} from "redux";
import {reducer as formReducer} from 'redux-form'
import thunk from "redux-thunk";
import {Provider} from "react-redux";
import AppReducer from "../reducers/AppReducer";
import I18NApp from "./I18NApp";

// Create Redux Store
const store = createStore(
    combineReducers({
        app: AppReducer,
        form: formReducer,
    }),
    compose(
        applyMiddleware(thunk)
    )
);

export default () => {
    return (
        <Provider store={store}>
            <I18NApp />
        </Provider>
    );
}